// @storybook-skip: internal section of ScreenHeaderBar; covered by its screen story
import Box from "../Box";
import { HeaderIconButton } from "./HeaderIconButton";
import type { ScreenHeaderAction } from "./types";

type Props = {
	actions: ScreenHeaderAction[];
	trailingContent?: React.ReactNode;
	iconColor: string;
};

export const HeaderTrailing = ({
	actions,
	trailingContent,
	iconColor,
}: Props) => {
	if (trailingContent) {
		return (
			<Box flexDirection="row" alignItems="center" marginRight={-4}>
				{trailingContent}
			</Box>
		);
	}

	if (!actions.length) {
		return null;
	}

	return (
		<Box flexDirection="row" alignItems="center" marginRight={-4}>
			{actions.map((action) => (
				<HeaderIconButton
					key={`${action.accessibilityLabel}-${action.icon}`}
					action={action}
					color={iconColor}
				/>
			))}
		</Box>
	);
};
